/**
 *
 * Section Navigation Scroll to Active Element
 */

module.exports = {
  init: function (className) {
    $('.' + className).each(function () {
      let activeEl = $(this).find('.mywort-section-navigation__entry--active').first();
      if (activeEl && activeEl.position()) {
        let scrollTo = activeEl.position().left;
        if(scrollTo > 0){
          $(this).scrollLeft(scrollTo - 30);
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./js/mywort/styleguide/section-navigation.js